import {
  FaBuilding,
  FaIndustry,
  FaHospital,
  FaSchool,
  FaHome,
  FaWarehouse,
} from "react-icons/fa";

const IndustriesSection = () => {
  const industries = [
    {
      icon: <FaHome />,
      title: "Residential",
    },
    {
      icon: <FaBuilding />,
      title: "Commercial",
    },
    {
      icon: <FaIndustry />,
      title: "Industrial",
    },
    {
      icon: <FaHospital />,
      title: "Healthcare",
    },
    {
      icon: <FaSchool />,
      title: "Education",
    },
    {
      icon: <FaWarehouse />,
      title: "Infrastructure",
    },
  ];

  return (
    <section className="py-12 md:py-24 bg-slate-50">
      <div className="container-custom">

        <div className="text-center mb-10 md:mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Industries
          </span>

          <h2 className="text-3xl sm:text-4xl font-bold text-[#082B57] mt-4">
            Industries We Serve
          </h2>

        </div>

        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-6">

          {industries.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-8 text-center shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden"
            >
              <div className="text-2xl sm:text-4xl text-[#F59E0B] mb-2 sm:mb-4 flex justify-center">
                {item.icon}
              </div>

              <h3 className="font-semibold text-[#082B57] text-[10px] sm:text-base leading-tight truncate">
                {item.title}
              </h3>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default IndustriesSection;